import { get, post, postFormData } from 'service/xhr/fetch'
import { URL_PREFIX } from 'utils/constant'

export const GET_ACCOUNT_TRANSACTION_PAGE_LIST = (data: any) => {
  return get(
    `/${URL_PREFIX}/insure-set/store-account/page-account-transaction`,
    data
  )
}

export const GET_CUSTOMER_TRANSACTION_PAGE_LIST = (data: any) => {
  return get(`/${URL_PREFIX}/pdt-store-account/page-account-transaction`, data)
}

export const GET_ACCOUNT_BALANCE = (pdtStoreId: string) => {
  return get(`/${URL_PREFIX}/insure-set/store-account/info-store-account`, {
    pdtStoreId
  })
}

export const GET_CUSTOMER_BALANCE = (pdtStoreId: string) => {
  return get(`/${URL_PREFIX}/pdt-store-account/info-store-account`, {
    pdtStoreId
  })
}

export const RECHARGE = (data: any) => {
  return post(`/${URL_PREFIX}/insure-set/store-account/recharge`, data)
}
